/**
 * Styles for the different button sizes
 */
import { LayoutProps, variant } from "@catchoftheday/theme";

export type ModalSizeVariantProp =
  | "content"
  | "x-small"
  | "small"
  | "medium"
  | "large";

const sizeVariantDefs: Record<ModalSizeVariantProp, LayoutProps> = {
  content: {},
  "x-small": {
    maxWidth: "400px",
  },
  small: {
    maxWidth: "500px",
  },
  medium: {
    maxWidth: "600px",
  },
  large: {
    maxWidth: "960px",
  },
};

export const sizeVariant = variant({
  prop: "sizeVariant",
  variants: sizeVariantDefs,
});
